<div class="page-container">
  <app-loader *ngIf="isLoadingExam" [text]="'Klausur wird geladen'"></app-loader>

  <div *ngIf="isCreatingQuestions" class="prep-container">
    <h1>Deine Probeklausur wird erstellt</h1>
    <app-progress-loader *ngIf="isCreatingQuestions" [duration]="15000" [messages]="['Deine Probeklausur wird vorbereitet ✨', 'Fiese Fragen werden erstellt 😉', 'Die KI macht eine kurze Kaffeepause ☕', 'Gutes braucht seine Zeit 💡']"></app-progress-loader>
  </div>

  <app-exam-run *ngIf="showExamRun" [exam]="exam!" (examFinished)="handleExamFinished($event)"></app-exam-run>
  <app-exam-result *ngIf="showResultPage" [(exam)]="exam!"></app-exam-result>
</div>